import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {CategoryType} from '../../types/CategoryType';
import {SeasonType} from '../../types/SeasonType';

export type ReportsFilterAndSort = {
    category?: CategoryType
    season?: SeasonType
    matchDay?: number
    sortBy?: 'matchDay' | 'airDate'
    desc?: boolean
}

const initialState: ReportsFilterAndSort = {
    category: undefined,
    season: undefined,
    matchDay: undefined,
    sortBy: undefined,
    desc: undefined
};

const myReportsSlice = createSlice({
    name: 'myReports',
    initialState,
    reducers: {
        reportsFilterAndOrderSet: (state, action: PayloadAction<ReportsFilterAndSort>) => {
            return action.payload;
        }
    }
});

export const {reportsFilterAndOrderSet} = myReportsSlice.actions;
export default myReportsSlice.reducer;
